import React from 'react';
import { ReactComponent as ChatAgentIcon } from 'modules/onboarding/OnboardingChatForm/components/InitWidget/welcome-message-icon.svg';
import { CHAT_TEST_ID_PREFIX } from 'modules/taboola-common-frontend-modules/chat-agent/constants';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { ChatBox } from '../ChatBox/ChatBox';
import { ChatContainer } from '../ChatContainer/ChatContainer';
import styles from './chatAgentContainer.module.scss';

const ChatAgentHeaderTitle = () => (
    <div className={styles['title']}>
        <ChatAgentIcon className={styles['chat-agent-icon']} />
        <FormattedMessage id="app.chat.agent.title" defaultMessage="Abby AI" />
    </div>
);

export const ChatAgentContainer = ({ chatContainerRef, isHidden, closeChat }) => {
    const testIdPrefix = CHAT_TEST_ID_PREFIX.CHAT_AGENT;

    return (
        <ChatContainer
            closeChat={closeChat}
            isHidden={isHidden}
            HeaderTitle={<ChatAgentHeaderTitle />}
            testIdPrefix={testIdPrefix}
        >
            <ChatBox ref={chatContainerRef} testIdPrefix={testIdPrefix} />
        </ChatContainer>
    );
};
